import { styled } from '@mui/material/styles';
import theme from 'theme/palette';

export const Container = styled('div')`
  .currency-notice {
    margin-top: 1.3rem;
  }
`;

export const accordionProps = {
  padding: '0px 10px',
  border: `1px solid ${theme.light.grey[300]}`,
  borderRadius: '10px !important',
};
